"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeleteCustomClaimRequestAction = void 0;
var tslib_1 = require("tslib");
var actions_1 = require("../../../constants/actions");
var createDeleteCustomClaimRequestAction = function (props) {
    return tslib_1.__assign({ type: actions_1.DELETE_CUSTOM_CLAIM_REQUEST }, props);
};
exports.createDeleteCustomClaimRequestAction = createDeleteCustomClaimRequestAction;
